import PropTypes from 'prop-types';
import { Box, Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { HIDE_BELOW_KEYS, resolveHeadCellDisplaySx } from './responsiveColumns';

const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  clip: 'rect(0 0 0 0)',
};

TableHeadCustom.propTypes = {
  sx: PropTypes.object,
  onSort: PropTypes.func,
  orderBy: PropTypes.string,
  headLabel: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.node,
      hideBelow: PropTypes.oneOf(HIDE_BELOW_KEYS),
      sortable: PropTypes.bool,
    })
  ),
  rowCount: PropTypes.number,
  numSelected: PropTypes.number,
  onSelectAllRows: PropTypes.any,
  order: PropTypes.oneOf(['asc', 'desc']),
  noRadius: PropTypes.bool,
};

export default function TableHeadCustom({
  order,
  orderBy,
  rowCount = 0,
  headLabel,
  numSelected = 0,
  onSort,
  onSelectAllRows,
  sx,
  noRadius = false,
}) {
  const headSx = {
    ...sx,
    ...(noRadius && {
      borderRadius: 0,
      '& .MuiTableCell-head:first-of-type': { borderTopLeftRadius: 0 },
      '& .MuiTableCell-head:last-of-type': { borderTopRightRadius: 0 },
    }),
  };

  // Com `sortable: false` a coluna fica sem botão. Sem a chave, ela segue ordenável quando há
  // `onSort`, que é o contrato de quem monta o cabeçalho à mão (FileListView).
  const isSortable = (headCell) => Boolean(onSort) && headCell.sortable !== false;

  return (
    <TableHead sx={headSx}>
      <TableRow>
        {onSelectAllRows && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={(event) => onSelectAllRows(event.target.checked)}
              inputProps={{ 'aria-label': 'Selecionar todos' }}
            />
          </TableCell>
        )}

        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align || 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              width: headCell.width,
              minWidth: headCell.minWidth,
              display: resolveHeadCellDisplaySx(headCell.hideBelow),
            }}
          >
            {isSortable(headCell) ? (
              <TableSortLabel
                hideSortIcon
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={() => onSort(headCell.id)}
                sx={{ textTransform: 'capitalize' }}
              >
                {headCell.label}

                {orderBy === headCell.id ? (
                  <Box sx={{ ...visuallyHidden }}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
